import { assetUseCaseEnum } from "kubb";
import { isNil } from "lodash-es";
import type React from "react";
import type {
  Option,
  SelectComboFieldProps,
} from "../Forms/SelectCombo/SelectCombo";
import { SelectListWrapper } from "../Forms/SelectCombo/SelectListWrapper";

const USE_CASE_LABEL: Record<string, string> = {
  [assetUseCaseEnum.DOMESTIC]: "Domestic",
  [assetUseCaseEnum.COMMERCIAL]: "Commercial",
  [assetUseCaseEnum.PROCESS]: "Process",
};

export default function AssetUseCaseSelect(
  props: Omit<SelectComboFieldProps, "options"> & {
    includeAll?: boolean;
    includeNone?: boolean;
  },
): React.ReactElement {
  const { label, includeAll, includeNone, ...rest } = props;
  const leadingOptions: Option[] = [
    includeAll ? { label: "All", value: "undefined" } : undefined,
    includeNone ? { label: "None", value: assetUseCaseEnum.NONE } : undefined,
  ].filter((v) => !isNil(v)) as Option[];

  return (
    <SelectListWrapper
      {...rest}
      label={label || { label: "Use Case" }}
      items={[
        assetUseCaseEnum.DOMESTIC,
        assetUseCaseEnum.COMMERCIAL,
        assetUseCaseEnum.PROCESS,
      ]}
      toOption={(useCase) => ({
        label: USE_CASE_LABEL[useCase],
        value: useCase,
      })}
      leadingOptions={leadingOptions}
    />
  );
}
